// https://flowbite.com/icons/


export const GoogleSvg = ({ width = '18', height = '18' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.0469 5.41592C1.55146 4.36449 2.26435 3.47581 3.16279 2.73688C4.38023 1.73102 5.77672 1.12555 7.34247 0.940006C9.18167 0.721907 10.9102 1.07021 12.5085 2.02725C12.9056 2.26488 13.2767 2.53506 13.6315 2.82803C13.7194 2.89964 13.7097 2.94196 13.6348 3.01357C12.9089 3.73623 12.183 4.45889 11.4636 5.18805C11.3789 5.27269 11.3334 5.26618 11.2422 5.19782C9.13284 3.57347 6.05667 4.01292 4.4844 6.16136C4.20771 6.53897 3.9831 6.94587 3.82685 7.38857C3.81383 7.42764 3.78779 7.46344 3.76825 7.50251C3.34833 7.1835 2.92516 6.86449 2.50849 6.54222C2.02021 6.16787 1.53193 5.79352 1.0469 5.41592Z"
                fill="#E94335"
            />
            <path
                d="M3.76825 10.5559C3.90823 10.8651 4.02542 11.1874 4.2012 11.4771C4.94013 12.6881 5.99482 13.466 7.38479 13.7427C8.63805 13.9934 9.84247 13.8241 10.9655 13.1959C11.0046 13.1763 11.0436 13.1568 11.0795 13.1373C11.099 13.1568 11.1153 13.1796 11.1348 13.1959C11.9746 13.8469 12.8177 14.498 13.6576 15.149C13.2539 15.5494 12.7949 15.8716 12.3067 16.1516C10.8907 16.9589 9.35745 17.2844 7.74287 17.1607C5.73115 17.0045 3.99612 16.2102 2.56383 14.7779C1.93557 14.1496 1.41799 13.44 1.04365 12.6295C1.39195 12.3625 1.74026 12.0989 2.08857 11.8319C2.64846 11.4055 3.20836 10.9823 3.76825 10.5559Z"
                fill="#34A853"
            />
            <path
                d="M13.6608 15.149C12.821 14.498 11.9779 13.8469 11.138 13.1959C11.1185 13.1796 11.099 13.1568 11.0827 13.1373C11.3724 12.9127 11.6686 12.6946 11.9063 12.4081C12.3034 11.9328 12.5671 11.3957 12.7038 10.7935C12.7201 10.7187 12.7071 10.6926 12.6322 10.6959C12.5931 10.6991 12.5573 10.6959 12.5183 10.6959C11.1901 10.6959 9.85875 10.6926 8.53062 10.6991C8.38414 10.6991 8.35159 10.6601 8.35484 10.5201C8.36135 9.57608 8.36135 8.63206 8.35484 7.68805C8.35484 7.56761 8.3874 7.53506 8.50784 7.53506C10.9427 7.53831 13.3776 7.53831 15.8158 7.53506C15.9199 7.53506 15.9623 7.5611 15.9883 7.67178C16.1869 8.56696 16.1739 9.4654 16.0534 10.3703C15.9558 11.093 15.78 11.7929 15.5098 12.47C15.1094 13.4693 14.5202 14.3417 13.7455 15.0904C13.7162 15.1132 13.6869 15.1295 13.6608 15.149Z"
                fill="#4285F3"
            />
            <path
                d="M3.76825 10.5559C3.20836 10.9823 2.64846 11.4055 2.08857 11.8319C1.74026 12.0956 1.39195 12.3625 1.04365 12.6295C0.773463 12.1282 0.597682 11.5976 0.454453 11.0507C0.181015 9.99274 0.138697 8.91852 0.288437 7.84105C0.405625 6.99469 0.649765 6.18089 1.04365 5.41917C1.53193 5.79352 2.01695 6.17113 2.50523 6.54548C2.92516 6.86774 3.34508 7.18675 3.765 7.50576C3.69339 7.85407 3.59247 8.19587 3.55992 8.55394C3.50133 9.20498 3.56318 9.83975 3.74872 10.4647C3.76174 10.4908 3.765 10.5233 3.76825 10.5559Z"
                fill="#FABB08"
            />
        </svg>
    );
}

export const GoogleLargeSvg = () => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.48436 8.54887C3.39256 6.65629 4.67577 5.05668 6.29295 3.72661C8.48436 1.91606 10.998 0.826215 13.8164 0.492231C17.1269 0.0996524 20.2383 0.726605 23.1152 2.44926C23.8301 2.877 24.498 3.36332 25.1367 3.89067C25.2949 4.01957 25.2773 4.09575 25.1426 4.22465C23.8359 5.52543 22.5293 6.82621 21.2344 8.13871C21.082 8.29106 21 8.27934 20.8359 8.15629C17.039 5.23247 11.5019 6.02348 8.67186 9.89067C8.17381 10.5704 7.76952 11.3028 7.48827 12.0997C7.46483 12.17 7.41795 12.2344 7.3828 12.3047C6.62694 11.7305 5.86522 11.1563 5.11522 10.5762C4.23631 9.90239 3.35741 9.22856 2.48436 8.54887Z"
                fill="#E94335"
            />
            <path
                d="M7.3828 17.8008C7.63475 18.3575 7.84569 18.9375 8.16209 19.459C9.49217 21.6387 11.3906 23.0391 13.8926 23.5372C16.1484 23.9883 18.3164 23.6836 20.3379 22.5528C20.4082 22.5176 20.4785 22.4825 20.543 22.4473C20.5781 22.4825 20.6074 22.5235 20.6426 22.5528C22.1543 23.7247 23.6719 24.8965 25.1836 26.0684C24.457 26.7891 23.6308 27.3692 22.7519 27.8731C20.2031 29.3262 17.4433 29.9122 14.5371 29.6895C10.916 29.4082 7.79295 27.9786 5.21483 25.4004C4.08397 24.2696 3.15233 22.9922 2.4785 21.5332C3.10545 21.0528 3.73241 20.5782 4.35936 20.0977C5.36717 19.3301 6.37498 18.5684 7.3828 17.8008Z"
                fill="#34A853"
            />
            <path
                d="M25.1894 26.0684C23.6777 24.8965 22.1601 23.7247 20.6484 22.5528C20.6133 22.5235 20.5781 22.4825 20.5488 22.4473C21.0703 22.043 21.6035 21.6504 22.0312 21.1348C22.7461 20.2793 23.2207 19.3125 23.4668 18.2286C23.4961 18.0938 23.4726 18.0469 23.3379 18.0528C23.2676 18.0586 23.2031 18.0528 23.1328 18.0528C20.7422 18.0528 18.3457 18.0469 15.9551 18.0586C15.6914 18.0586 15.6328 17.9883 15.6387 17.7364C15.6504 16.0372 15.6504 14.3379 15.6387 12.6387C15.6387 12.4219 15.6973 12.3633 15.914 12.3633C20.2969 12.3692 24.6797 12.3692 29.0683 12.3633C29.2558 12.3633 29.332 12.4102 29.3789 12.6094C29.7363 14.2207 29.7129 15.8379 29.4961 17.4668C29.3203 18.7676 29.0039 20.0274 28.5176 21.2461C27.7969 23.045 26.7363 24.6153 25.3418 25.9629C25.289 26.0039 25.2363 26.0332 25.1894 26.0684Z"
                fill="#4285F3"
            />
            <path
                d="M7.3828 17.8008C6.37498 18.5684 5.36717 19.3301 4.35936 20.0977C3.73241 20.5723 3.10545 21.0528 2.4785 21.5332C1.99217 20.6309 1.67577 19.6758 1.41795 18.6915C0.925766 16.7872 0.849594 14.8536 1.11913 12.9141C1.33006 11.3907 1.76952 9.92583 2.4785 8.55473C3.35741 9.22856 4.23045 9.90825 5.10936 10.5821C5.86522 11.1622 6.62108 11.7364 7.37694 12.3106C7.24803 12.9375 7.06639 13.5528 7.0078 14.1973C6.90233 15.3692 7.01366 16.5118 7.34764 17.6368C7.37108 17.6836 7.37694 17.7422 7.3828 17.8008Z"
                fill="#FABB08"
            />
        </svg>
    );
}

export const AppleSvg = ({ width = '18', height = '18' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.67578 4.82679C5.3431 4.80726 5.89649 5.03512 6.45313 5.24345C6.70052 5.33786 6.94792 5.43226 7.20508 5.50062C7.4069 5.55595 7.60222 5.52991 7.79427 5.4583C8.12631 5.33785 8.45508 5.21741 8.78711 5.09371C9.36654 4.87887 9.96224 4.73239 10.5807 4.77145C11.7363 4.84306 12.7161 5.29228 13.4616 6.20049C13.5918 6.35674 13.582 6.37301 13.4193 6.48694C12.2116 7.33655 11.6842 8.50517 11.847 9.96676C11.9902 11.2656 12.6771 12.1966 13.8359 12.7858C13.9857 12.8606 14.015 12.929 13.9596 13.082C13.5723 14.1399 13.0254 15.1067 12.3092 15.9759C12.0944 16.2363 11.8763 16.4902 11.6224 16.7083C11.0527 17.1933 10.4082 17.3007 9.68881 17.1119C9.32097 17.0143 8.97917 16.8483 8.61784 16.7278C7.92123 16.5 7.23438 16.5423 6.54427 16.7636C6.18295 16.8808 5.84115 17.0403 5.47331 17.1412C4.75716 17.3398 4.1517 17.164 3.61784 16.6627C2.71289 15.8164 2.04232 14.804 1.54102 13.681C1.17318 12.8672 0.909508 12.0078 0.766278 11.1158C0.587242 10.0123 0.574221 8.91533 0.912763 7.83786C1.1862 6.95569 1.65821 6.20049 2.39063 5.63082C3.07422 5.10022 3.85222 4.81377 4.67578 4.82679Z"
                fill="#181914"
            />
            <path
                d="M7.29298 4.24082C7.32554 3.20892 7.77475 2.38209 8.53973 1.71152C9.09311 1.22649 9.7409 0.946546 10.457 0.813083C10.5677 0.793551 10.6133 0.809827 10.6166 0.933525C10.6263 2.15748 10.1738 3.1666 9.2396 3.96087C8.73504 4.39056 8.15887 4.60215 7.49806 4.60866C7.3353 4.61191 7.26694 4.56634 7.28973 4.40032C7.29949 4.35149 7.29298 4.29616 7.29298 4.24082Z"
                fill="#181914"
            />
        </svg>
    );
};

export const AppleLargeSvg = () => {
    return (
        <svg
            width="25"
            height="30"
            viewBox="0 0 25 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.81639 7.48829C9.01756 7.45313 10.0137 7.86329 11.0156 8.23829C11.4609 8.40821 11.9062 8.57813 12.3691 8.70118C12.7324 8.80079 13.084 8.75391 13.4297 8.62501C14.0273 8.40821 14.6191 8.19141 15.2168 7.96876C16.2597 7.58204 17.332 7.31837 18.4453 7.38868C20.5254 7.51759 22.289 8.32618 23.6308 9.96095C23.8652 10.2422 23.8476 10.2715 23.5547 10.4766C21.3808 12.0059 20.4316 14.1094 20.7246 16.7402C20.9824 19.0781 22.2187 20.7539 24.3047 21.8145C24.5742 21.9492 24.6269 22.0723 24.5273 22.3477C23.8301 24.252 22.8457 25.9922 21.5566 27.5566C21.1699 28.0254 20.7773 28.4824 20.3203 28.875C19.2949 29.7481 18.1347 29.9414 16.8398 29.6016C16.1777 29.4258 15.5625 29.127 14.9121 28.9102C13.6582 28.5 12.4219 28.5762 11.1797 28.9746C10.5293 29.1856 9.91404 29.4727 9.25193 29.6543C7.96287 30.0117 6.87303 29.6953 5.91209 28.793C4.28318 27.2695 3.07615 25.4473 2.17381 23.4258C1.5117 21.9609 1.03709 20.4141 0.779277 18.8086C0.457011 16.8223 0.433574 14.8477 1.04295 12.9082C1.53514 11.3203 2.38475 9.96095 3.7031 8.93556C4.93357 7.98048 6.33396 7.46485 7.81639 7.48829Z"
                fill="#181914"
            />
            <path
                d="M12.5273 6.43362C12.5859 4.5762 13.3945 3.08791 14.7715 1.88088C15.7676 1.00784 16.9336 0.50393 18.2226 0.263695C18.4219 0.228539 18.5039 0.257836 18.5098 0.480492C18.5273 2.68362 17.7129 4.50002 16.0312 5.92971C15.123 6.70315 14.0859 7.08401 12.8965 7.09573C12.6035 7.10159 12.4805 7.01955 12.5215 6.72073C12.5391 6.63284 12.5273 6.53323 12.5273 6.43362Z"
                fill="#181914"
            />
        </svg>
    );
};

export const VkSvg = ({ width = '18', height = '18' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 7.68C0 4.05962 0 2.24942 1.12471 1.12471C2.24942 0 4.05962 0 7.68 0H8.32C11.9404 0 13.7506 0 14.8753 1.12471C16 2.24942 16 4.05962 16 7.68V8.32C16 11.9404 16 13.7506 14.8753 14.8753C13.7506 16 11.9404 16 8.32 16H7.68C4.05962 16 2.24942 16 1.12471 14.8753C0 13.7506 0 11.9404 0 8.32V7.68Z"
                fill="#0077FF"
            />
            <path
                d="M8.51334 11.5267C4.86667 11.5267 2.78668 9.0267 2.70001 4.8667H4.52668C4.58668 7.92003 5.93332 9.21336 6.99998 9.48003V4.8667H8.72004V7.50001C9.77337 7.38668 10.8799 6.1867 11.2532 4.8667H12.9733C12.6866 6.49337 11.4866 7.69336 10.6333 8.18668C11.4866 8.58668 12.8534 9.63336 13.3734 11.5267H11.48C11.0733 10.26 10.06 9.28003 8.72004 9.14668V11.5267H8.51334Z"
                fill="white"
            />
        </svg>
    );
};

export const VkLargeSvg = () => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 14.4C0 7.61178 0 4.21767 2.10883 2.10883C4.21767 0 7.61178 0 14.4 0H15.6C22.3882 0 25.7823 0 27.8912 2.10883C30 4.21767 30 7.61178 30 14.4V15.6C30 22.3882 30 25.7823 27.8912 27.8912C25.7823 30 22.3882 30 15.6 30H14.4C7.61178 30 4.21767 30 2.10883 27.8912C0 25.7823 0 22.3882 0 15.6V14.4Z"
                fill="#0077FF"
            />
            <path
                d="M15.9626 21.6125C9.12504 21.6125 5.22507 16.925 5.06256 9.125H8.48757C8.60007 14.85 11.125 17.275 13.125 17.775V9.125H16.3501V14.0625C18.3251 13.85 20.3999 11.6 21.0999 9.125H24.325C23.7875 12.175 21.5375 14.425 19.9375 15.35C21.5375 16.1 24.1001 18.0625 25.0751 21.6125H21.525C20.7625 19.2375 18.8626 17.4 16.3501 17.15V21.6125H15.9626Z"
                fill="white"
            />
        </svg>
    );
};

export const MailSvg = ({ width = '18', height = '18' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{paddingTop: '4px'}}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 0H2C1.175 0 0.5075 0.675 0.5075 1.5L0.5 10.5C0.5 11.325 1.175 12 2 12H14C14.825 12 15.5 11.325 15.5 10.5V1.5C15.5 0.675 14.825 0 14 0ZM13.25 10.5H2.75C2.3375 10.5 2 10.1625 2 9.75V3L7.205 6.255C7.6925 6.5625 8.3075 6.5625 8.795 6.255L14 3V9.75C14 10.1625 13.6625 10.5 13.25 10.5ZM8 5.25L2 1.5H14L8 5.25Z"
                fill="#2368A2"
            />
        </svg>
    );
}

export const MailLargeSvg = () => {
    return (
        <svg
            width="30"
            height="24"
            viewBox="0 0 30 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M27 0H3C1.35 0 0 1.35 0 3V21C0 22.65 1.35 24 3 24H27C28.65 24 30 22.65 30 21V3C30 1.35 28.65 0 27 0ZM26.4 6.375L16.59 12.51C15.615 13.125 14.385 13.125 13.41 12.51L3.6 6.375C3.225 6.135 3 5.73 3 5.295C3 4.29 4.095 3.69 4.95 4.215L15 10.5L25.05 4.215C25.905 3.69 27 4.29 27 5.295C27 5.73 26.775 6.135 26.4 6.375Z"
                fill="white"
            />
        </svg>
    );
}

export const ProfileHeaderMenuSvg = () => {
    return (
        <svg
            width="14"
            height="10"
            viewBox="0 0 14 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 9.5H13C13.4125 9.5 13.75 9.1625 13.75 8.75C13.75 8.3375 13.4125 8 13 8H1C0.5875 8 0.25 8.3375 0.25 8.75C0.25 9.1625 0.5875 9.5 1 9.5ZM1 5.75H13C13.4125 5.75 13.75 5.4125 13.75 5C13.75 4.5875 13.4125 4.25 13 4.25H1C0.5875 4.25 0.25 4.5875 0.25 5C0.25 5.4125 0.5875 5.75 1 5.75ZM0.25 1.25C0.25 1.6625 0.5875 2 1 2H13C13.4125 2 13.75 1.6625 13.75 1.25C13.75 0.8375 13.4125 0.5 13 0.5H1C0.5875 0.5 0.25 0.8375 0.25 1.25Z"
                fill="white"
            />
        </svg>
    );
}

export const EditProfileSettingsSvg = () => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.25 11.095V13.375C0.25 13.585 0.415 13.75 0.625 13.75H2.905C3.0025 13.75 3.1 13.7125 3.1675 13.6375L11.3575 5.45501L8.545 2.64251L0.3625 10.825C0.2875 10.9 0.25 10.99 0.25 11.095ZM13.5325 3.28001C13.825 2.98751 13.825 2.51501 13.5325 2.22251L11.7775 0.467513C11.485 0.175013 11.0125 0.175013 10.72 0.467513L9.3475 1.84001L12.16 4.65251L13.5325 3.28001Z"
                fill="#7BA4C7"
            />
        </svg>
    );
}

export const LogoutProfileSettingsSvg = () => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.0925 10.2175C6.385 10.51 6.8575 10.51 7.15 10.2175L9.8425 7.525C10.135 7.2325 10.135 6.76 9.8425 6.4675L7.15 3.775C6.8575 3.4825 6.385 3.4825 6.0925 3.775C5.8 4.0675 5.8 4.54 6.0925 4.8325L7.5025 6.25H1C0.5875 6.25 0.25 6.5875 0.25 7C0.25 7.4125 0.5875 7.75 1 7.75H7.5025L6.0925 9.16C5.8 9.4525 5.8075 9.9325 6.0925 10.2175ZM12.25 0.25H1.75C0.9175 0.25 0.25 0.925 0.25 1.75V4C0.25 4.4125 0.5875 4.75 1 4.75C1.4125 4.75 1.75 4.4125 1.75 4V2.5C1.75 2.0875 2.0875 1.75 2.5 1.75H11.5C11.9125 1.75 12.25 2.0875 12.25 2.5V11.5C12.25 11.9125 11.9125 12.25 11.5 12.25H2.5C2.0875 12.25 1.75 11.9125 1.75 11.5V10C1.75 9.5875 1.4125 9.25 1 9.25C0.5875 9.25 0.25 9.5875 0.25 10V12.25C0.25 13.075 0.925 13.75 1.75 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V1.75C13.75 0.925 13.075 0.25 12.25 0.25Z"
                fill="#7BA4C7"
            />
        </svg>
    );
}

export const RemoveProfileSettingsSvg = () => {
    return (
        <svg
            width="14"
            height="10"
            viewBox="0 0 14 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 9.5H13C13.4125 9.5 13.75 9.1625 13.75 8.75C13.75 8.3375 13.4125 8 13 8H1C0.5875 8 0.25 8.3375 0.25 8.75C0.25 9.1625 0.5875 9.5 1 9.5ZM1 5.75H13C13.4125 5.75 13.75 5.4125 13.75 5C13.75 4.5875 13.4125 4.25 13 4.25H1C0.5875 4.25 0.25 4.5875 0.25 5C0.25 5.4125 0.5875 5.75 1 5.75ZM0.25 1.25C0.25 1.6625 0.5875 2 1 2H13C13.4125 2 13.75 1.6625 13.75 1.25C13.75 0.8375 13.4125 0.5 13 0.5H1C0.5875 0.5 0.25 0.8375 0.25 1.25Z"
                fill="#7BA4C7"
            />
        </svg>
    );
}

export const ArrowDownPaymentSvg = () => {
    return (
        <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.09 16.5325L14 13.6225L16.91 16.5325C17.2025 16.825 17.675 16.825 17.9675 16.5325C18.26 16.24 18.26 15.7675 17.9675 15.475L14.525 12.0325C14.2325 11.74 13.76 11.74 13.4675 12.0325L10.025 15.475C9.7325 15.7675 9.7325 16.24 10.025 16.5325C10.3175 16.8175 10.7975 16.825 11.09 16.5325Z"
                fill="#2368A2"/>
        </svg>
    );
}

export const PaymentIdCopySvg = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 15 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.25 0.75H2C1.175 0.75 0.5 1.425 0.5 2.25V12C0.5 12.4125 0.8375 12.75 1.25 12.75C1.6625 12.75 2 12.4125 2 12V3C2 2.5875 2.3375 2.25 2.75 2.25H10.25C10.6625 2.25 11 1.9125 11 1.5C11 1.0875 10.6625 0.75 10.25 0.75ZM13.25 3.75H5C4.175 3.75 3.5 4.425 3.5 5.25V15.75C3.5 16.575 4.175 17.25 5 17.25H13.25C14.075 17.25 14.75 16.575 14.75 15.75V5.25C14.75 4.425 14.075 3.75 13.25 3.75ZM12.5 15.75H5.75C5.3375 15.75 5 15.4125 5 15V6C5 5.5875 5.3375 5.25 5.75 5.25H12.5C12.9125 5.25 13.25 5.5875 13.25 6V15C13.25 15.4125 12.9125 15.75 12.5 15.75Z"
                fill="#2368A2"
            />
        </svg>
    );
}

export const ArrowUpPaymentSvg = () => {
    return (
        <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.09 12.4675L14 15.3775L16.91 12.4675C17.2025 12.175 17.675 12.175 17.9675 12.4675C18.26 12.76 18.26 13.2325 17.9675 13.525L14.525 16.9675C14.2325 17.26 13.76 17.26 13.4675 16.9675L10.025 13.525C9.7325 13.2325 9.7325 12.76 10.025 12.4675C10.3175 12.1825 10.7975 12.175 11.09 12.4675Z"
                fill="#2368A2"/>
        </svg>
    );
};

export const FooterPaymentIconSvg = () => {
    return (
        <svg
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14 0H2C1.1675 0 0.5075 0.6675 0.5075 1.5L0.5 10.5C0.5 11.3325 1.1675 12 2 12H14C14.8325 12 15.5 11.3325 15.5 10.5V1.5C15.5 0.6675 14.8325 0 14 0ZM13.25 10.5H2.75C2.3375 10.5 2 10.1625 2 9.75V6H14V9.75C14 10.1625 13.6625 10.5 13.25 10.5ZM14 3H2V1.5H14V3Z"
                fill="#2368A2"
            />
        </svg>
    );
}

export const ArrowBackSvg = ({ fill = '#2368A2' }) => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.2499 5.25004H2.87236L6.53236 1.59004C6.82486 1.29754 6.82486 0.817539 6.53236 0.525039C6.23986 0.232539 5.76736 0.232539 5.47486 0.525039L0.532363 5.46754C0.239863 5.76004 0.239863 6.23254 0.532363 6.52504L5.47486 11.4675C5.76736 11.76 6.23986 11.76 6.53236 11.4675C6.82486 11.175 6.82486 10.7025 6.53236 10.41L2.87236 6.75004H11.2499C11.6624 6.75004 11.9999 6.41254 11.9999 6.00004C11.9999 5.58754 11.6624 5.25004 11.2499 5.25004Z"
                fill={fill}
            />
        </svg>
    );
}

export const PaymentMethodCardSvg = () => {
    return (
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_95_1078)">
                <path
                    d="M13.8 2.66667H3.13333C2.39333 2.66667 1.80667 3.26 1.80667 4L1.8 12C1.8 12.74 2.39333 13.3333 3.13333 13.3333H13.8C14.54 13.3333 15.1333 12.74 15.1333 12V4C15.1333 3.26 14.54 2.66667 13.8 2.66667ZM13.1333 12H3.8C3.43333 12 3.13333 11.7 3.13333 11.3333V8H13.8V11.3333C13.8 11.7 13.5 12 13.1333 12ZM13.8 5.33333H3.13333V4H13.8V5.33333Z"
                    fill="#A3A3A1"
                />
            </g>
            <defs>
                <clipPath id="clip0_95_1078">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0.466667)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

export const PaymentMethodYooMoneySvg = () => {
    return (
        <svg
            width="23"
            height="16"
            viewBox="0 0 23 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_151_2539)">
                <path
                    d="M14.9987 0C10.543 0 6.9987 3.59493 6.9987 8C6.9987 12.4557 10.5936 16 14.9987 16C19.4037 16 22.9987 12.4051 22.9987 8C22.9987 3.59493 19.4037 0 14.9987 0ZM14.9987 10.9873C13.3784 10.9873 12.0114 9.62025 12.0114 8C12.0114 6.37975 13.3784 5.01265 14.9987 5.01265C16.6189 5.01265 17.986 6.37975 17.986 8C17.9355 9.62025 16.6189 10.9873 14.9987 10.9873Z"
                    fill="#BFBFBE"
                />
                <path
                    d="M6.94768 2.32912V13.9747H4.11224L0.466667 2.32912H6.94768Z"
                    fill="#BFBFBE"
                />
            </g>
            <defs>
                <clipPath id="clip0_151_2539">
                    <rect
                        width="22.5333"
                        height="16"
                        fill="white"
                        transform="translate(0.466667)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

export const LanguageSvg = () => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.99333 0.333328C3.31333 0.333328 0.333328 3.31999 0.333328 7C0.333328 10.68 3.31333 13.6667 6.99333 13.6667C10.68 13.6667 13.6667 10.68 13.6667 7C13.6667 3.31999 10.68 0.333328 6.99333 0.333328ZM11.6133 4.33333H9.64666C9.43333 3.49999 9.12666 2.7 8.72666 1.96C9.95333 2.38 10.9733 3.23333 11.6133 4.33333ZM7 1.69333C7.55333 2.49333 7.98666 3.38 8.27333 4.33333H5.72666C6.01333 3.38 6.44666 2.49333 7 1.69333ZM1.84 8.33333C1.73333 7.90666 1.66666 7.46 1.66666 7C1.66666 6.54 1.73333 6.09333 1.84 5.66666H4.09333C4.03999 6.10666 3.99999 6.54666 3.99999 7C3.99999 7.45333 4.03999 7.89333 4.09333 8.33333H1.84ZM2.38666 9.66666H4.35333C4.56666 10.5 4.87333 11.3 5.27333 12.04C4.04666 11.62 3.02666 10.7733 2.38666 9.66666ZM4.35333 4.33333H2.38666C3.02666 3.22666 4.04666 2.38 5.27333 1.96C4.87333 2.7 4.56666 3.49999 4.35333 4.33333ZM7 12.3067C6.44666 11.5067 6.01333 10.62 5.72666 9.66666H8.27333C7.98666 10.62 7.55333 11.5067 7 12.3067ZM8.56 8.33333H5.43999C5.37999 7.89333 5.33333 7.45333 5.33333 7C5.33333 6.54666 5.37999 6.1 5.43999 5.66666H8.56C8.62 6.1 8.66666 6.54666 8.66666 7C8.66666 7.45333 8.62 7.89333 8.56 8.33333ZM8.72666 12.04C9.12666 11.3 9.43333 10.5 9.64666 9.66666H11.6133C10.9733 10.7667 9.95333 11.62 8.72666 12.04ZM9.90666 8.33333C9.96 7.89333 10 7.45333 10 7C10 6.54666 9.96 6.10666 9.90666 5.66666H12.16C12.2667 6.09333 12.3333 6.54 12.3333 7C12.3333 7.46 12.2667 7.90666 12.16 8.33333H9.90666Z"
                fill="white"
            />
        </svg>
    );
}

export const ProviderSelectActiveSvg = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_15_932)">
                <path
                    d="M8 1.33333C4.32 1.33333 1.33333 4.32 1.33333 8C1.33333 11.68 4.32 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8C14.6667 4.32 11.68 1.33333 8 1.33333ZM8 13.3333C5.05333 13.3333 2.66667 10.9467 2.66667 8C2.66667 5.05333 5.05333 2.66667 8 2.66667C10.9467 2.66667 13.3333 5.05333 13.3333 8C13.3333 10.9467 10.9467 13.3333 8 13.3333Z"
                    fill="#2368A2"
                />
                <path
                    d="M8 11.3333C9.84095 11.3333 11.3333 9.84095 11.3333 8C11.3333 6.15905 9.84095 4.66667 8 4.66667C6.15905 4.66667 4.66667 6.15905 4.66667 8C4.66667 9.84095 6.15905 11.3333 8 11.3333Z"
                    fill="#2368A2"
                />
            </g>
            <defs>
                <clipPath id="clip0_15_932">
                    <rect width="16" height="16" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export const ProviderSelectNoActiveSvg = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_299_41)">
                <path
                    d="M8 1.33333C4.31999 1.33333 1.33333 4.32 1.33333 8C1.33333 11.68 4.31999 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8C14.6667 4.32 11.68 1.33333 8 1.33333ZM8 13.3333C5.05333 13.3333 2.66666 10.9467 2.66666 8C2.66666 5.05333 5.05333 2.66667 8 2.66667C10.9467 2.66667 13.3333 5.05333 13.3333 8C13.3333 10.9467 10.9467 13.3333 8 13.3333Z"
                    fill="#D3E1EC"
                />
            </g>
            <defs>
                <clipPath id="clip0_299_41">
                    <rect width="16" height="16" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export const EyeSvg = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="16"
            height="16"
            fill="#2368a2"
        >
            <path
                d="M21.92,11.6C19.9,6.91,16.1,4,12,4S4.1,6.91,2.08,11.6a1,1,0,0,0,0,.8C4.1,17.09,7.9,20,12,20s7.9-2.91,9.92-7.6A1,1,0,0,0,21.92,11.6ZM12,18c-3.17,0-6.17-2.29-7.9-6C5.83,8.29,8.83,6,12,6s6.17,2.29,7.9,6C18.17,15.71,15.17,18,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z"
            />
        </svg>
    );
}

export const CrossedOutEyeSvg = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="16"
            height="16"
            fill="#2368a2"
        >
            <path
                d="M10.94,6.08A6.93,6.93,0,0,1,12,6c3.18,0,6.17,2.29,7.91,6a15.23,15.23,0,0,1-.9,1.64,1,1,0,0,0-.16.55,1,1,0,0,0,1.86.5,15.77,15.77,0,0,0,1.21-2.3,1,1,0,0,0,0-.79C19.9,6.91,16.1,4,12,4a7.77,7.77,0,0,0-1.4.12,1,1,0,1,0,.34,2ZM3.71,2.29A1,1,0,0,0,2.29,3.71L5.39,6.8a14.62,14.62,0,0,0-3.31,4.8,1,1,0,0,0,0,.8C4.1,17.09,7.9,20,12,20a9.26,9.26,0,0,0,5.05-1.54l3.24,3.25a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Zm6.36,9.19,2.45,2.45A1.81,1.81,0,0,1,12,14a2,2,0,0,1-2-2A1.81,1.81,0,0,1,10.07,11.48ZM12,18c-3.18,0-6.17-2.29-7.9-6A12.09,12.09,0,0,1,6.8,8.21L8.57,10A4,4,0,0,0,14,15.43L15.59,17A7.24,7.24,0,0,1,12,18Z"
            />
        </svg>
    );
}

export const ClosureSvg = ({ fill = '#ffff' }) => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.3 0.710215C12.91 0.320215 12.28 0.320215 11.89 0.710215L6.99997 5.59022L2.10997 0.700215C1.71997 0.310215 1.08997 0.310215 0.699971 0.700215C0.309971 1.09021 0.309971 1.72022 0.699971 2.11022L5.58997 7.00022L0.699971 11.8902C0.309971 12.2802 0.309971 12.9102 0.699971 13.3002C1.08997 13.6902 1.71997 13.6902 2.10997 13.3002L6.99997 8.41021L11.89 13.3002C12.28 13.6902 12.91 13.6902 13.3 13.3002C13.69 12.9102 13.69 12.2802 13.3 11.8902L8.40997 7.00022L13.3 2.11022C13.68 1.73022 13.68 1.09022 13.3 0.710215Z"
            />
        </svg>
    );
}

export const YandexSvg = ({ width = '18', height = '18' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.53003 9C1.53003 4.85775 4.88703 1.5 9.03003 1.5C13.1715 1.5 16.53 4.85775 16.53 9C16.53 13.1423 13.1715 16.5 9.03003 16.5C4.88703 16.5 1.53003 13.1423 1.53003 9Z"
                fill="#FC3F1D"
            />
            <path
                d="M9.99005 5.74942H9.29705C8.02655 5.74942 7.3583 6.39292 7.3583 7.34167C7.3583 8.41417 7.8203 8.91667 8.76905 9.56092L9.5528 10.0889L7.30055 13.4542H5.61755L7.6388 10.4437C6.4763 9.61042 5.8238 8.80117 5.8238 7.43242C5.8238 5.71642 7.02005 4.54492 9.2888 4.54492H11.5411V13.4459H9.99005V5.74942Z"
                fill="white"
            />
        </svg>
    );
};

export const YandexLargeSvg = () => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.06 18C3.06 9.7155 9.774 3 18.06 3C26.343 3 33.06 9.7155 33.06 18C33.06 26.2845 26.343 33 18.06 33C9.774 33 3.06 26.2845 3.06 18Z"
                fill="#FC3F1D"
            />
            <path
                d="M19.98 11.499H18.594C16.053 11.499 14.7165 12.786 14.7165 14.6835C14.7165 16.8285 15.6405 17.8335 17.538 19.122L19.1055 20.178L14.601 26.9085H11.235L15.2775 20.8875C12.9525 19.221 11.6475 17.6025 11.6475 14.865C11.6475 11.433 14.04 9.09 18.5775 9.09H23.082V26.892H19.98V11.499Z"
                fill="white"
            />
        </svg>
    );
};

export const TelegramSvg = ({ width = '18', height = '18' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width={width}
            height={height}
            viewBox="0 0 48 48"
        >
            <path fill="#29b6f6" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"/>
            <path fill="#fff"
                  d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z"/>
            <path fill="#b0bec5"
                  d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z"/>
            <path fill="#cfd8dc"
                  d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z"/>
        </svg>
    );
}

export const TelegramLargeSvg = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="36"
            height="36"
            viewBox="0 0 48 48"
        >
            <path fill="#29b6f6" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"/>
            <path fill="#fff"
                  d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z"/>
            <path fill="#b0bec5"
                  d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z"/>
            <path fill="#cfd8dc"
                  d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z"/>
        </svg>
    );
}

export const ReceiptSvg = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M18.4358 3.66932C18.8601 4.10226 19.4703 4.22496 20 4.03743V19.9764C19.468 19.7837 18.8527 19.9052 18.4258 20.3409M18.4358 3.66932L19.15 2.96939M18.4358 3.66932L18.005 3.22974L17.5742 3.66932C16.9821 4.27349 16.0279 4.27349 15.4358 3.66932L15.005 3.22974L14.5742 3.66932C13.9821 4.27349 13.0279 4.27349 12.4358 3.66932L12.005 3.22974L11.5742 3.66932C10.9821 4.27349 10.0279 4.27349 9.43579 3.66932L8.99727 3.22185L8.5686 3.66481L8.56421 3.66932C7.97212 4.27349 7.01788 4.27349 6.42579 3.66932L6.4214 3.66481L5.995 3.2242L5.5686 3.66481L5.56421 3.66932C5.13993 4.10226 4.52969 4.22496 4 4.03743V19.9728C4.52969 19.7852 5.13993 19.9079 5.56421 20.3409M18.4258 20.3409L19.14 21.0408M18.4258 20.3409L17.995 20.7805L17.5642 20.3409C16.9721 19.7367 16.0179 19.7367 15.4258 20.3409L14.995 20.7805L14.5642 20.3409C13.9721 19.7367 13.0179 19.7367 12.4258 20.3409L11.995 20.7805L11.5642 20.3409C10.9721 19.7367 10.0179 19.7367 9.42579 20.3409M9.42579 20.3409L10.14 21.0408M9.42579 20.3409L8.995 20.7805L8.56421 20.3409M8.56421 20.3409L7.85 21.0408M8.56421 20.3409C7.97212 19.7367 7.01788 19.7367 6.42579 20.3409M6.42579 20.3409L7.14 21.0408M6.42579 20.3409L5.995 20.7805L5.56421 20.3409M5.56421 20.3409L4.85 21.0408"
                stroke="#2368A2"
                stroke-width="2"
            />
            <path xmlns="http://www.w3.org/2000/svg" d="M8 15H12" stroke="#2368A2" stroke-width="2" stroke-linecap="round"/>
            <path xmlns="http://www.w3.org/2000/svg" d="M8 12H16" stroke="#2368A2" stroke-width="2" stroke-linecap="round"/>
            <path xmlns="http://www.w3.org/2000/svg" d="M8 9H16" stroke="#2368A2" stroke-width="2" stroke-linecap="round"/>
        </svg>
    );
}

export const UpSvg = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="18"
            height="18"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path d="M2,21L23,12L2,3V10L17,12L2,14V21Z"/>
        </svg>
    );
};

export const FacebookSvg = ({width = '18', height = '18'}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_236_1031)">
                <path
                    d="M10 19.3091C15.1413 19.3091 19.3091 15.1413 19.3091 10C19.3091 4.85874 15.1413 0.690918 10 0.690918C4.85874 0.690918 0.690918 4.85874 0.690918 10C0.690918 15.1413 4.85874 19.3091 10 19.3091Z"
                    fill="#3F65A6"
                />
                <path
                    d="M8.58552 6.93823C8.58552 7.20732 8.58552 8.40732 8.58552 8.40732H7.50916V10.2037H8.58552V15.1273H10.7964V10.2H12.2801C12.2801 10.2 12.4182 9.33823 12.4873 8.39641C12.2946 8.39641 10.8073 8.39641 10.8073 8.39641C10.8073 8.39641 10.8073 7.35278 10.8073 7.16732C10.8073 6.9855 11.0473 6.73823 11.2873 6.73823C11.5237 6.73823 12.0255 6.73823 12.491 6.73823C12.491 6.4946 12.491 5.64732 12.491 4.86914C11.8692 4.86914 11.1637 4.86914 10.8546 4.86914C8.53097 4.87278 8.58552 6.66914 8.58552 6.93823Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_236_1031">
                    <rect width="20" height="20" fill="white"/>
                </clipPath>
            </defs>
        </svg>

    );
};

export const PlayNowSvg = () => {
    return (
        <svg
            width="49"
            height="48"
            viewBox="0 0 49 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.04 22.5H8.06726C8.70273 15.4483 13.7748 9.67588 20.4708 7.99547C20.0741 8.49413 19.6628 9.05159 19.2519 9.66795C17.2924 12.6072 15.3408 16.8902 15.04 22.5ZM24.3107 8.18566C24.376 8.12027 24.4392 8.05812 24.5 7.99921C24.5608 8.05812 24.624 8.12027 24.6893 8.18566C25.3814 8.8777 26.3153 9.92713 27.2519 11.3321C28.9519 13.8821 30.6597 17.5992 30.9551 22.5H18.0449C18.3403 17.5992 20.0481 13.8821 21.7481 11.3321C22.6847 9.92713 23.6186 8.8777 24.3107 8.18566ZM25.8454 25.5H18.0449C18.3403 30.4008 20.0481 34.1179 21.7481 36.6679C22.6847 38.0729 23.6186 39.1223 24.3107 39.8143C24.376 39.8797 24.4392 39.9419 24.5 40.0008C24.5608 39.9419 24.624 39.8797 24.6893 39.8143C25.3814 39.1223 26.3153 38.0729 27.2519 36.6679C27.6855 36.0176 28.1195 35.2913 28.5306 34.4889L29.7 38.4038C29.3051 38.9918 28.9104 39.5253 28.5292 40.0045C29.0432 39.8755 29.5477 39.7224 30.0414 39.5464L30.9012 42.425C28.8962 43.1215 26.7423 43.5 24.5 43.5C13.7304 43.5 5 34.7696 5 24C5 13.2304 13.7304 4.5 24.5 4.5C35.2696 4.5 44 13.2304 44 24C44 25.4693 43.8375 26.9006 43.5295 28.2769L40.652 27.3873C40.7807 26.7702 40.875 26.1404 40.9327 25.5H34.5475L34.5 25.4853L25.841 25.4853L25.8454 25.5ZM19.2519 38.3321C19.6628 38.9484 20.0741 39.5059 20.4708 40.0045C13.7748 38.3241 8.70273 32.5517 8.06726 25.5H15.04C15.3408 31.1098 17.2924 35.3928 19.2519 38.3321ZM33.96 22.5H40.9327C40.2973 15.4483 35.2252 9.67588 28.5292 7.99547C28.9259 8.49413 29.3372 9.05159 29.7481 9.66795C31.7076 12.6072 33.6592 16.8902 33.96 22.5Z"
                fill="white"
            />
            <path
                d="M30.8873 29.0197C30.757 28.6288 31.1289 28.2569 31.5198 28.3872L47.3612 33.6677C47.8171 33.8197 47.8171 34.4645 47.3612 34.6164L39.9149 37.0985C39.7656 37.1483 39.6484 37.2654 39.5986 37.4147L37.1165 44.8612C36.9645 45.317 36.3197 45.317 36.1678 44.8612L30.8873 29.0197Z"
                fill="white"
            />
        </svg>
    );
}

export const InfoSvg = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.25 4.25H8.75V5.75H7.25V4.25ZM8 11.75C8.4125 11.75 8.75 11.4125 8.75 11V8C8.75 7.5875 8.4125 7.25 8 7.25C7.5875 7.25 7.25 7.5875 7.25 8V11C7.25 11.4125 7.5875 11.75 8 11.75ZM8 0.5C3.86 0.5 0.5 3.86 0.5 8C0.5 12.14 3.86 15.5 8 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 8 0.5ZM8 14C4.6925 14 2 11.3075 2 8C2 4.6925 4.6925 2 8 2C11.3075 2 14 4.6925 14 8C14 11.3075 11.3075 14 8 14Z"
                fill="#2368A2"/>
        </svg>

    );
}

export const IsOkSvg = () => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2589_2789)">
                <path
                    d="M15 2.5C8.1 2.5 2.5 8.1 2.5 15C2.5 21.9 8.1 27.5 15 27.5C21.9 27.5 27.5 21.9 27.5 15C27.5 8.1 21.9 2.5 15 2.5ZM11.6125 20.3625L7.125 15.875C6.6375 15.3875 6.6375 14.6 7.125 14.1125C7.6125 13.625 8.4 13.625 8.8875 14.1125L12.5 17.7125L21.1 9.1125C21.5875 8.625 22.375 8.625 22.8625 9.1125C23.35 9.6 23.35 10.3875 22.8625 10.875L13.375 20.3625C12.9 20.85 12.1 20.85 11.6125 20.3625Z"
                    fill="#259D58"/>
            </g>
            <defs>
                <clipPath id="clip0_2589_2789">
                    <rect width="30" height="30" fill="white"/>
                </clipPath>
            </defs>
        </svg>

    );
}

export const IsTimeInfoSvg = () => {
    return (
        <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.0447 2.58664C20.5751 3.12782 21.3379 3.2812 22 3.04679V22.9704C21.335 22.7296 20.5659 22.8815 20.0322 23.4261L20.925 24.301L20.0322 23.4261L19.4937 23.9756L18.9553 23.4261C18.2151 22.6709 17.0224 22.6709 16.2822 23.4261L15.7438 23.9756L15.2053 23.4261C14.4651 22.6709 13.2724 22.6709 12.5322 23.4261L11.9938 23.9756L11.4553 23.4261C10.7151 22.6709 9.52235 22.6709 8.78224 23.4261L8.24375 23.9756L7.70527 23.4261C6.96515 22.6709 5.77235 22.6709 5.03224 23.4261L4.49375 23.9756L3.95527 23.4261C3.42491 22.8849 2.66211 22.7316 2 22.966V3.04679C2.66211 3.2812 3.42491 3.12782 3.95527 2.58665L3.95528 2.58666L3.96075 2.58102L4.49375 2.03025L5.02675 2.58102L5.02673 2.58103L5.03223 2.58665C5.77235 3.34187 6.96515 3.34187 7.70527 2.58665L7.70528 2.58666L7.71075 2.58102L8.24659 2.02732L8.79473 2.58665C9.53485 3.34187 10.7276 3.34187 11.4678 2.58665L12.0062 2.03717L12.5447 2.58665C13.2848 3.34187 14.4776 3.34187 15.2178 2.58665L15.7562 2.03717L16.2947 2.58665C17.0348 3.34187 18.2277 3.34187 18.9678 2.58665L19.5063 2.03717L20.0447 2.58664ZM11.5572 1.57899L11.5577 1.57949C11.5576 1.57932 11.5574 1.57916 11.5572 1.57899L12.0062 1.13896L11.5572 1.57899ZM15.3072 1.57899L15.3077 1.57949C15.3076 1.57932 15.3074 1.57916 15.3072 1.57899L15.7562 1.13896L15.3072 1.57899Z"
                stroke="#E88D3A" stroke-width="2.5"/>
            <path
                d="M8.25 8V9.98125C8.25 10.3125 8.38125 10.6313 8.61875 10.8688L10.75 13L8.6125 15.1375C8.38125 15.375 8.25 15.6938 8.25 16.025V18C8.25 18.6875 8.8125 19.25 9.5 19.25H14.5C15.1875 19.25 15.75 18.6875 15.75 18V16.025C15.75 15.6938 15.6188 15.375 15.3875 15.1438L13.25 13L15.3812 10.875C15.6187 10.6375 15.75 10.3187 15.75 9.9875V8C15.75 7.3125 15.1875 6.75 14.5 6.75H9.5C8.8125 6.75 8.25 7.3125 8.25 8Z"
                fill="#E88D3A"/>
        </svg>
    );
}

export const PaymentStateErrorSvg = () => {
    return (
        <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.5 0.5C5.5875 0.5 0 6.0875 0 13C0 19.9125 5.5875 25.5 12.5 25.5C19.4125 25.5 25 19.9125 25 13C25 6.0875 19.4125 0.5 12.5 0.5ZM17.875 18.375C17.3875 18.8625 16.6 18.8625 16.1125 18.375L12.5 14.7625L8.8875 18.375C8.4 18.8625 7.6125 18.8625 7.125 18.375C6.6375 17.8875 6.6375 17.1 7.125 16.6125L10.7375 13L7.125 9.3875C6.6375 8.9 6.6375 8.1125 7.125 7.625C7.6125 7.1375 8.4 7.1375 8.8875 7.625L12.5 11.2375L16.1125 7.625C16.6 7.1375 17.3875 7.1375 17.875 7.625C18.3625 8.1125 18.3625 8.9 17.875 9.3875L14.2625 13L17.875 16.6125C18.35 17.0875 18.35 17.8875 17.875 18.375Z"
                fill="#B01E1E"/>
        </svg>
    );
}

export const SupportImageSvg = () => {
    return (
        <svg viewBox="0 0 18 18">
            <rect className="ql-stroke" height="10" width="12" x="3" y="4"></rect>
            <circle className="ql-fill" cx="6" cy="7" r="1"></circle>
            <polyline className="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline>
        </svg>
    );
}

export const SupportVideoSvg = () => {
    return (
        <svg viewBox="0 0 18 18">
            <rect className="ql-stroke" height="12" width="12" x="3" y="3"></rect>
            <rect className="ql-fill" height="12" width="1" x="5" y="3"></rect>
            <rect className="ql-fill" height="12" width="1" x="12" y="3"></rect>
            <rect className="ql-fill" height="2" width="8" x="5" y="8"></rect>
            <rect className="ql-fill" height="1" width="3" x="3" y="5"></rect>
            <rect className="ql-fill" height="1" width="3" x="3" y="7"></rect>
            <rect className="ql-fill" height="1" width="3" x="3" y="10"></rect>
            <rect className="ql-fill" height="1" width="3" x="3" y="12"></rect>
            <rect className="ql-fill" height="1" width="3" x="12" y="5"></rect>
            <rect className="ql-fill" height="1" width="3" x="12" y="7"></rect>
            <rect className="ql-fill" height="1" width="3" x="12" y="10"></rect>
            <rect className="ql-fill" height="1" width="3" x="12" y="12"></rect>
        </svg>
    );
}

export const PaymentMethodCryptoSvg = () => {
    return (
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="8.5"
                cy="8"
                r="6"
                stroke="#A3A3A1"
                strokeWidth="1.5"
            />
            <path
                d="M8.5 4.5V11.5"
                stroke="#A3A3A1"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
            <path
                d="M6.7 6.2H9.2C10 6.2 10.4 6.6 10.4 7.1C10.4 7.6 10 8 9.2 8H6.7"
                stroke="#A3A3A1"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
            <path
                d="M6.7 8H9.4C10.2 8 10.7 8.4 10.7 9C10.7 9.6 10.2 10 9.4 10H6.7"
                stroke="#A3A3A1"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
        </svg>
    );
};